import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components';
import ClusterTabs from '../../Components/company/components/ClusterTabs';
import { Waypoint } from 'react-waypoint';
import CompanyInfo from '../../Components/company/components/CompanyInfo';
import { useDispatch, useSelector } from 'react-redux';
import { selectAllCompanyDetailsLoading, selectClusterCompanyNews, selectClusterCompanyNewsLoading, selectClusterCompanyNewsFilter, selectClusterCompanyNewsFilterLoading, selectClusterCompanyNewsFilterSelected, selectClusterCompanyProfile, selectClusterCompanyProfileLoading, selectClusterStrategicHighlights, selectClusterStrategicHighlightsLoading, selectClusterSWOTLoading, selectClusterSWOTData, selectClusterCompanyPageNumber, selectClusterCompanyNewsFiltersApplied, selectClusterCompanyNewsCompanyIdsApplied, selectClusterNewsFilterApplied, selectClusterSwotRefreshedCompany, selectClusterProductAndServicesLoading, selectClusterProductAndServices } from '../../Selector/ClustersSelector';
import { Col, Row, Spin } from 'antd';
import CompanyDetails from '../../Components/company/components/CompanyDetails';
import { actions as clusterActions } from '../../Slice/ClustersSlice';
import StrategicHighlights from '../../Components/common/components/StrategicHighlights';
import { appBgColor, loadingGifV6, loadingGifV7, maxMobile, maxTablet, maxWidth, maxWidth1300, minTablet, primaryFont, primaryHeadingColor, retina, secondaryFont, wMBold, wMedium } from '../../Utils/utilsStyle';
import { SelectedCompany } from '../../Types/ClustersTypes';
import SwotTab from '../../Components/company/components/SwotTab';
import SwotAnalysis from '../../Components/company/components/SwotAnalysis';
import StrategicHighlightsSkeleton from '../../Components/common/skeleton/StrategicHighlightsSkeleton';
import CompanyDetailsTab from '../../Components/company/components/CompanyDetailsTab';
import Financials from '../../Components/company/components/Financials';
import CompanyNewsTab from '../../Components/company/components/CompanyNewsTab';
import ViewTabs from '../../Components/common/tabs/ViewTabs';
import { ViewInterface } from '../../Types/GlobalTypes';
import { selectViewTab } from '../../Selector/UISelector';
import classNames from 'classnames';
import { Article } from '../../Types/ArticleTypes';
import FilterPopOver from '../../Components/common/components/FilterPopOver';
import { Filter } from '../../Types/FilterTypes';
import { allValueInKeyOfArrayExists, anyValueInKeyOfArrayExists, getLocalStorageObject, isAPrivateCompany, IsTablet, scrollWithId } from '../../Utils/UtilityFunctions';
import ClusterFilterPopover from '../../Components/company/components/ClusterFilterPopover';
import { actions as UiAction } from '../../Slice/UISlice';
import CompanyCardSkeleton from '../../Components/common/skeleton/CompanyCardSkeleton';
import ProductAndServices from '../../Components/company/components/ProductAndServices';
import ClusterSubsidiaryList from '../../Components/company/components/ClusterSubsidiaryList';
import { selectClusterSubsidiaries } from 'Selector/ClustersSelector';

const Wrapper = styled.div`
  .tabs-header-scroll {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .tabs-header {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: max-content;
    position: sticky;
    top: 80px;
    z-index: 1;
    background: ${appBgColor};
    padding: 12px 0;
    @media all and (max-width: ${maxTablet}) {
      top: 65px;
    }
    .right-side-sub-header {
      &.disabledFilter {
        pointer-events: none;
        opacity: 0.5;
      }
      display: flex;
      align-items: center;
      column-gap: 8px;
      flex-shrink: 0;
      position: absolute;
      right: 0%;
      @media all and (max-width: ${maxWidth}), ${retina} {
        position: unset;
      }
      @media all and (max-width: ${maxTablet}) {
        column-gap: 0px;
      }
      .view-tabs {
        .tabs-wrapper {
          .tabs-item {
            height: 34px;
            svg {
              height: 32px;
            }
          }
        }
      }
      .filter-placeholder {
        .tabs-wrapper {
          .ant-btn {
            min-height: 34px;
          }
        } 
      }

    }
  }
  margin-top: 24px;
  .content-wrapper {
    margin-top: 24px;
    min-height: 355px;
    border-radius: 12px;
    /* background: #fff; */
    /* padding: 24px; */
    .container-company-card {
      background: white;
      padding: 0px 0px 24px;
      border-radius: 16px;
      margin-bottom: 16px;
      box-shadow: 0 0 17px -2px rgba(0, 0, 0, 0.04);
      .company-info-wrapper {
        .bottom-btn-div {
          display: none;
        }
      }
      .company-details-btns-slider {
        display: none;
      }
      .body-part {
        margin-top: 32px;
      }
    }
    .highlights-section {
      display: flex;
      flex-direction: column;
      justify-content: center;
      row-gap: 15px;
      margin-bottom: 15px;
      .company-name {
        color: ${primaryHeadingColor};
        font-family: ${secondaryFont};
        font-size: 20px;
        font-weight: ${wMBold};
        line-height: normal;
        letter-spacing: -0.65px;
      }
    }
    .swot-section {
      background-color: rgb(255, 255, 255);
      border-radius: 16px;
      padding: 24px;
      margin-bottom: 16px;
      .swot-tab-area {
        .sticky-header-swot {
          position: unset;
        }
      }

      @media all and (max-width: ${maxWidth}), ${retina} {
        border-radius: 12px;
        padding-top: 16px;
        padding-bottom: 16px;
      }
    }
    .details-section {
      display: flex;
      flex-direction: column;
      row-gap: 16px; 
      .company-name {
        color: ${primaryHeadingColor};
        font-family: ${secondaryFont};
        font-size: 20px;
        font-weight: ${wMBold};
        line-height: normal;
        letter-spacing: -0.65px;
      }
      .details {
        .company-details-heading {
          display: none;
        }
      }
    }
    .financials-section {
      display: flex;
      flex-direction: column;
      row-gap: 8px;
      .company-name {
        color: ${primaryHeadingColor};
        font-family: ${secondaryFont};
        font-size: 20px;
        font-weight: ${wMBold};
        line-height: normal;
        letter-spacing: -0.65px;
      }
      .fin-div {
        #tabs-details {
          .company-financial-heading {
            display: none;
          }
        }
      }
      &.empty-state {
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${primaryHeadingColor};
        text-align: center;
        font-family: ${primaryFont};
        font-size: 14px;
        font-weight: ${wMedium};
        line-height: 20px;
        min-height: 355px;
      }
    }
    .triggers-section {
      .companyNewsTabWrapper {
        .triggerWrapper {
          background: none;
          border-radius: 0px;
          box-shadow: none;
        }
        .highlight-skeleton {
          display: none;
        }
        .swot-analysis-area {
          display: none;
        }
        .listviewTagsAndStatsWrapper {
          display: none;
        }
        .tagsAndIntentDataWrapper {
          display: none;
        }
        .progress-wrapper {
          display: none;
        }
        #trigger-details {
          .spotlight-wrapper {
            padding: 0px;
          }
          .heading-inner-page {
            margin-bottom: 16px;
            padding: 0px
          }
          .infiniteScrollWrapper {
            padding: 0px;
          }
        }
      }
    }
    .product-services-section {
      display: flex;
      flex-direction: column;
      justify-content: center;
      row-gap: 15px;
      margin-bottom: 15px;
      .company-name {
        color: ${primaryHeadingColor};
        font-family: ${secondaryFont};
        font-size: 20px;
        font-weight: ${wMBold};
        line-height: normal;
        letter-spacing: -0.65px;
      }
    }
    .empty-state {
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${primaryHeadingColor};
        text-align: center;
        font-family: ${primaryFont};
        font-size: 14px;
        font-weight: ${wMedium};
        line-height: 20px;
        min-height: 355px;
        background: none;
      }
  }
`;
type Props = {
  clusterId: number
  appliedCompanies: SelectedCompany[]
  handleHighlightClick?: (prompt: string) => void,
  onGilroyClose?: () => void;
}

const defaultProps = {
  clusterId: 0,
  appliedCompanies: [],
  onGilroyClose: () => { },
}
const ClusterInsightSection = function ClusterInsightSection(props: Props) {
  const { clusterId, appliedCompanies, handleHighlightClick, onGilroyClose = () => { } } = props
  const dispatch = useDispatch();

  const selectedCompanies = appliedCompanies;
  const [tabPending, setTabPending] = useState(false);
  const [initialised, setInitialised] = useState(false);
  const [activeTab, setActiveTab] = useState('Overview');
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const loadedTabsRef = useRef<Record<string, string>>({});
  const pendingOverviewRef = useRef(false);
  const companyProfile = useSelector(selectClusterCompanyProfile);
  const companyProfileLoading = useSelector(selectClusterCompanyProfileLoading);
  const strategicHighligths = useSelector(selectClusterStrategicHighlights);
  const strategicHighlightsLoading = useSelector(selectClusterStrategicHighlightsLoading);
  const swotData = useSelector(selectClusterSWOTData);
  const allCompanyDetailsLoading = useSelector(selectAllCompanyDetailsLoading)
  const selectedCompaniesId = selectedCompanies.map((company) => company.companyId);
  const swotLoading = useSelector(selectClusterSWOTLoading);
  const isTab = IsTablet();
  const tabView: ViewInterface = useSelector(selectViewTab);
  const isListView = tabView.view === 'listView';
  const getPath = getLocalStorageObject('ViewTab') as ViewInterface;
  const [disableFilter, setDisableFilter] = useState(true);
  const companyNewsArticles: Article[] | null = useSelector(selectClusterCompanyNews);

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    window.requestAnimationFrame(() => {
      scrollContainerRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    });
  };
  const companyNewsLoading: boolean = useSelector(selectClusterCompanyNewsLoading);
  const companyPageNumber = useSelector(selectClusterCompanyPageNumber);
  const [filters, setFilters] = useState<Filter[]>([]);
  const [previousNewsFiltersApplied, setPreviousNewsFiltersApplied] = useState<Filter[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(true);
  const [isFilterActive, setIsFilterActive] = useState<boolean>(false);
  const [isFilterChanged, setIsFilterChanged] = useState<boolean>(false);
  const newsFiltersFromRedux = useSelector(selectClusterCompanyNewsFilter);
  const selectedNewsFilters = useSelector(selectClusterCompanyNewsFilterSelected);
  const [selectedFilterCompanies, setSelectedFilterCompanies] = useState<number[]>(selectedCompaniesId);
  const [previousSelectedCompanyIds, setPreviousSelectedCompanyIds] = useState<number[]>(selectedCompaniesId);
  const companyNewsFiltersLoading = useSelector(selectClusterCompanyNewsFilterLoading);
  const filtersApplied = useSelector(selectClusterCompanyNewsFiltersApplied);
  const companyNewsCompanyIdsApplied = useSelector(selectClusterCompanyNewsCompanyIdsApplied);
  const clusterNewsFilterApplied = useSelector(selectClusterNewsFilterApplied);
  const swotRefreshedClusterCompany = useSelector(selectClusterSwotRefreshedCompany);
  const productAndServicesLoading = useSelector(selectClusterProductAndServicesLoading);
  const productsAndServicesData = useSelector(selectClusterProductAndServices);
  const subsidiariesData = useSelector(selectClusterSubsidiaries);

  const getNewsCompanyIds = () => (
    companyNewsCompanyIdsApplied || selectedCompaniesId.join(',')
  );

  const hasCompanyFinancialData = (profile: any) => {
    if (!profile || isAPrivateCompany(profile)) return false;
    const financialInfo = profile.companyFinancialInfo;
    if (!financialInfo) return false;
    if (financialInfo.sections?.length) return true;
    if (financialInfo.earningAndReports?.length) return true;
    return false;
  };

  const companiesWithFinancials = selectedCompanies?.filter((company) => {
    const profile = companyProfile[company.companyId];
    return hasCompanyFinancialData(profile);
  }) || [];

  const strategicLoading = selectedCompanies.some(company => strategicHighlightsLoading[company.companyId]);
  const swotTabLoading = selectedCompanies.some(company => swotLoading[company.companyId]);
  const financialLoading = selectedCompanies.some(company => companyProfileLoading[company.companyId]);
  const detailsLoading = selectedCompanies.some(company => companyProfileLoading[company.companyId]);
  const subsidiariesInitialLoading = selectedCompanies.some((company) => {
    const entry = subsidiariesData[company.companyId];
    return !entry || (entry.loading && !entry.items.length);
  });
  const hasSubsidiaries = selectedCompanies.some(
    (company) => subsidiariesData[company.companyId]?.items.length,
  );
  // Subsidiaries tab only shows once a selected company is known to have subsidiaries
  const tabs = [
    'Overview',
    'Strategic Highlights',
    'S.W.O.T Analysis',
    'Sales Triggers',
    'Financials',
    'Product and Services',
    'Details',
    ...(hasSubsidiaries ? ['Subsidiaries'] : []),
  ];

  useEffect(() => {
    if (activeTab === 'Subsidiaries' && !hasSubsidiaries && !subsidiariesInitialLoading) {
      setActiveTab('Overview');
    }
  }, [activeTab, hasSubsidiaries, subsidiariesInitialLoading]);


  useEffect(() => {
    loadedTabsRef.current = {};
  }, [clusterId])

  useEffect(() => {
    if (activeTab !== 'Overview') {
      pendingOverviewRef.current = true;
      setActiveTab('Overview');
    }
  }, [selectedCompanies]);

  useEffect(() => {
    setSelectedFilterCompanies(selectedCompaniesId);
    setPreviousSelectedCompanyIds(selectedCompaniesId);
    dispatch(clusterActions.setClusterCompanyNewsCompanyIdsApplied(''));
  }, [selectedCompaniesId.join(',')]);

  useEffect(() => {
    if (companyNewsCompanyIdsApplied) {
      const ids = companyNewsCompanyIdsApplied.split(',').map(Number);
      setSelectedFilterCompanies(ids);
      setPreviousSelectedCompanyIds(ids);
    }
  }, [companyNewsCompanyIdsApplied]);

  useEffect(() => {
    if (!companyNewsFiltersLoading) {
      setDisableFilter(false)
    }
  }, [companyNewsFiltersLoading])

  useEffect(() => {
    dispatch(UiAction.isTabView({
      view: getPath.view,
    }));
  }, [getPath.view]);

  useEffect(() => {
    if (isFilterChanged) {
      if (
        anyValueInKeyOfArrayExists(
          filters,
          'isSelected',
          false
        )
      ) {
        setIsFilterActive(true);
      } else {
        setIsFilterActive(false);
      }

      setIsFilterChanged(false);
    }
  }, [isFilterChanged, filters]);

  useEffect(() => {
    if (selectedNewsFilters.length) {
      const filterId = selectedNewsFilters.split(',');
      const filterTemp = newsFiltersFromRedux.map((filter) => {
        if (filterId.includes(filter.filterId)) {
          return { ...filter, isSelected: true };
        }
        return { ...filter, isSelected: false };
      });
      setFilters(filterTemp);
      setPreviousNewsFiltersApplied(filterTemp);
    } else {
      setFilters(newsFiltersFromRedux);
      setPreviousNewsFiltersApplied(newsFiltersFromRedux);
    }

    setSelectAll(allValueInKeyOfArrayExists(newsFiltersFromRedux, 'isSelected', true));
  }, [newsFiltersFromRedux]);

  useEffect(() => {
    if (swotRefreshedClusterCompany && selectedCompaniesId.includes(swotRefreshedClusterCompany)) {
      dispatch(clusterActions.getClusterSWOTAnalysis({ companyId: swotRefreshedClusterCompany }));
      dispatch(clusterActions.setClusterSwotRefreshedCompany(0));
    }
  }, [dispatch, selectedCompaniesId, swotRefreshedClusterCompany]);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'Overview':
        return (
          <>
            {
              selectedCompanies?.map((company, index) => {
                const profile = companyProfile[company.companyId];
                const loading = companyProfileLoading[company.companyId];
                if (!profile && !loading) return null;
                return (
                  <Waypoint>
                    <div className={`container-company-card `} id="certification-company-tabs">
                      {loading && !profile ? (
                        <div className="overview-loading-card" >
                          <CompanyCardSkeleton />
                        </div>
                      ) : (
                        <>
                          <Row>
                            <Col
                              xxl={{ span: 6 }}
                              xl={{ span: 8 }}
                              lg={{ span: 8 }}
                              md={{ span: 8 }}
                              sm={{ span: 24 }}
                              xs={{ span: 24 }}
                            >
                              {companyProfile && (
                                <CompanyInfo
                                  companyProfile={profile}
                                  isCluster
                                  companyIndex={index + 1}
                                  totalCompanies={selectedCompanies.length}
                                  onSubsidiariesClick={() => handleTabChange('Subsidiaries')}
                                />
                              )}
                            </Col>
                            <Col
                              xxl={{ span: 18 }}
                              xl={{ span: 16 }}
                              lg={{ span: 16 }}
                              md={{ span: 16 }}
                              sm={{ span: 24 }}
                              xs={{ span: 24 }}
                              className="second-col-area"
                            >
                              {companyProfile &&
                                <CompanyDetails
                                  companyProfile={profile}
                                  showSAPHierarchy={false}
                                  userCompanyId={company.companyId}
                                  isCluster
                                />
                              }
                            </Col>
                          </Row>
                        </>
                      )}
                    </div>
                  </Waypoint>
                )
              })

            }

          </>
        );
      case 'Strategic Highlights': {
        const hasRequested = loadedTabsRef.current['Strategic Highlights'];
        if (!hasRequested || strategicLoading) {
          return (
            <div className="not-applied-section">
              <Spin />
            </div>
          )
        }

        const highlightCompanies = selectedCompanies.filter(company => strategicHighligths[company.companyId]?.length);

        if (!highlightCompanies.length) {
          return (
            <div className="financials-section empty-state">
              No strategic highlights available.
            </div>
          );
        }

        return (
          <>
            {highlightCompanies.map(company => (
              <div
                key={company.companyId}
                className="highlights-section"
              >
                <div className="company-name">
                  {company.companyName}
                </div>

                <StrategicHighlights
                  strategicHighlights={
                    strategicHighligths[company.companyId]
                  }
                  handleClick={handleHighlightClick}
                  onGilroyClose={onGilroyClose}
                  isCluster
                  clusterLoading={
                    strategicHighlightsLoading[company.companyId]
                  }
                />
              </div>
            ))}
          </>
        )
      }
      case 'S.W.O.T Analysis': {
        const hasRequested = loadedTabsRef.current['S.W.O.T Analysis'];
        if (!hasRequested || swotTabLoading) {
          return (
            <div className="not-applied-section">
              <Spin />
            </div>
          )
        }

        const swotCompanies = selectedCompanies.filter(company => swotData[company.companyId]?.swotAnalysis?.length);

        if (!swotCompanies.length) {
          return (
            <div className='swot-section empty-state'>
              No SWOT Analysis Available
            </div>
          )
        }
        return (
          <>
            {
              swotCompanies.map((company) => (
                <div key={company.companyId} className='swot-section'>
                  <SwotAnalysis
                    isSwotTab={true}
                    isCluster={true}
                    clusterCompanyId={company.companyId}
                    clusterCompanyName={company.companyName}
                  />
                </div>
              ))
            }

          </>
        )
      }
      case 'Sales Triggers':
        const hasRequested = loadedTabsRef.current['Sales Triggers'];
        if (!hasRequested || companyNewsLoading && companyPageNumber === 1) {
          return (
            <div className="not-applied-section">
              <Spin />
            </div>
          );
        }

        if (!companyNewsArticles?.length) {
          return (
            <div className="empty-state">
              We couldn't find any recent sales triggers. Try to select another company
            </div>
          );
        }

        return (
          <div className="triggers-section">
            <CompanyNewsTab
              listview={isListView}
              onGilroyClose={onGilroyClose}
              isCluster
              clusterCompanyIdsApplied={selectedCompaniesId.join(',')}
            />
          </div>
        );
      case 'Financials': {
        const hasRequested = loadedTabsRef.current['Financials'];
        if (financialLoading) {
          return (
            <div className="not-applied-section">
              <Spin />
            </div>
          )
        }
        if (!companiesWithFinancials.length) {
          return (
            <div className='financials-section empty-state'>
              No public Financials data found
            </div>
          );
        }

        return (
          <>
            {
              companiesWithFinancials.map((company) => (
                <div key={company.companyId} className='financials-section'>
                  <div className='company-name'>
                    {company.companyName}
                  </div>
                  <div className='fin-div'>
                    <Financials
                      redirect=""
                      isCluster
                      clusterCompanyId={company.companyId}
                      setClusterTab={setActiveTab}
                    />
                  </div>
                </div>
              ))
            }
          </>
        )

      }
      case 'Product and Services': {
        const hasRequested = loadedTabsRef.current['Product and Services'];
        const isInitialPsLoad = selectedCompanies.some(
          (company) => productAndServicesLoading[company.companyId]
            && !productsAndServicesData[company.companyId],
        );
        if (!hasRequested || isInitialPsLoad) {
          return (
            <div className='not-applied-section'><Spin /></div>
          )
        }
        const psCompanies = selectedCompanies.filter((company) => {
          const companyData = productsAndServicesData[company.companyId];

          return (
            companyData?.products?.length > 0 ||
            companyData?.services?.length > 0
          );
        });
        if (!psCompanies.length) {
          return (
            <div className='financials-section empty-state'>
              No Products and Services available.
            </div>
          )
        }

        return (
          <>
            {
              psCompanies.map(company => (
                <div
                  key={company.companyId}
                  className='product-services-section'
                >
                  <div className='company-name'>
                    {company.companyName}
                  </div>
                  <ProductAndServices
                    isCluster={true}
                    clusterCompanyId={company.companyId}
                  />
                </div>
              ))
            }
          </>
        )
      }
      case 'Subsidiaries': {
        // Driven by store data, not loadedTabsRef: page 1 is usually already loaded by the
        // Overview tab, so no dispatch (and no re-render) happens when this tab opens
        if (subsidiariesInitialLoading) {
          return (
            <div className='not-applied-section'><Spin /></div>
          );
        }
        const companiesWithSubsidiaries = selectedCompanies.filter(
          (company) => subsidiariesData[company.companyId]?.items.length,
        );
        if (!companiesWithSubsidiaries.length) {
          return (
            <div className='financials-section empty-state'>
              No Subsidiaries available.
            </div>
          );
        }
        return (
          <>
            {companiesWithSubsidiaries.map((company) => (
              <ClusterSubsidiaryList
                key={company.companyId}
                companyId={company.companyId}
                companyName={company.companyName}
                entry={subsidiariesData[company.companyId]}
              />
            ))}
          </>
        );
      }
      case 'Details': {
        const hasRequested = loadedTabsRef.current['Details'];
        if (detailsLoading) {
          return (
            <div className="not-applied-section">
              <Spin />
            </div>
          )
        }
        const companiesWithDetails = selectedCompanies.filter(company => companyProfile[company.companyId]);
        if (!companiesWithDetails.length) {
          return (
            <div className='details-section empty-state'>
              No Details available
            </div>
          );
        }
        return (
          <>
            {
              companiesWithDetails.map((company) => (
                <div key={company.companyId} className="details-section">
                  <div className="company-name">{company.companyName}</div>
                  <div className='details'>
                    <CompanyDetailsTab
                      isCluster={true}
                      companyId={company.companyId}
                    />
                  </div>
                </div>
              ))
            }
          </>
        )
      }

      default:
        return null;
    }
  };

  useEffect(() => {
    if (!selectedCompanies?.length) return;

    const companiesKey = selectedCompanies
      .map((company) => company.companyId)
      .sort((a, b) => a - b)
      .join(',');

    if (pendingOverviewRef.current && activeTab !== 'Overview') {
      return;
    }

    if (pendingOverviewRef.current && activeTab === 'Overview') {
      pendingOverviewRef.current = false;
    }

    const cacheKey = activeTab === 'Sales Triggers'
      ? `${companiesKey}-${filtersApplied}-${getNewsCompanyIds()}`
      : companiesKey;

    const alreadyLoaded = loadedTabsRef.current[activeTab] === cacheKey;

    if (alreadyLoaded) {
      return;
    }

    switch (activeTab) {
      case 'Overview':
        selectedCompanies?.forEach((company) => {
          dispatch(clusterActions.getClusterCompanyProfile({
            companyId: company.companyId,
          }));
          dispatch(clusterActions.getClusterStocksChart({
            companyId: company.companyId,
          }))
          // Page 1 gives the count for the overview card and is reused by the Subsidiaries tab
          dispatch(clusterActions.getClusterSubsidiaries({
            companyId: company.companyId,
            page: 1,
          }));
        })
        break;

      case 'Strategic Highlights':
        selectedCompanies?.forEach((company) => {
          dispatch(clusterActions.getClusterStrategicHighlight({
            id: company.companyId,
            type: 'company',
            key: 'company_strategic_highlights',
          }));
        })

        break;

      case 'S.W.O.T Analysis':
        selectedCompanies?.forEach((company) => {
          dispatch(clusterActions.getClusterSWOTAnalysis({
            companyId: company.companyId
          }));
        })
        break;

      case 'Sales Triggers':
        dispatch(clusterActions.getClusterCompanyNews({
          companyId: getNewsCompanyIds(),
          page: 1,
          ...filtersApplied.length ? {
            newsFilters: filtersApplied
          } : {},
        }))
        break;

      case 'Financials':
        selectedCompanies?.forEach((company) => {
          if (!companyProfile[company.companyId]) {
            dispatch(clusterActions.getClusterCompanyProfile({
              companyId: company.companyId,
            }));
          }
          dispatch(clusterActions.getClusterStocksChart({
            companyId: company.companyId,
          }));
          dispatch(clusterActions.getClusterCompanySecFillings({
            companyId: company.companyId,
          }));
        });
        break;

      case 'Product and Services':
        selectedCompanies?.forEach((company) => {
          dispatch(clusterActions.getClusterProductAndServices({
            companyId: company.companyId,
          }));
        });
        break;

      case 'Subsidiaries':
        selectedCompanies?.forEach((company) => {
          // Already fetched (or in flight) from the Overview tab
          if (subsidiariesData[company.companyId]) return;
          dispatch(clusterActions.getClusterSubsidiaries({
            companyId: company.companyId,
            page: 1,
          }));
        });
        break;

      default: break;
    }
    loadedTabsRef.current[activeTab] = cacheKey;
  }, [activeTab, selectedCompanies, filtersApplied, companyNewsCompanyIdsApplied]);

  useEffect(() => {
    const ids = filtersApplied ? filtersApplied.split(',') : [];

    const filterTemp = newsFiltersFromRedux.map(filter => ({
      ...filter,
      isSelected: ids.includes(filter.filterId),
    }));

    setFilters(filterTemp);
    setPreviousNewsFiltersApplied(filterTemp);
    setIsFilterChanged(true);
  }, [newsFiltersFromRedux, filtersApplied]);

  const onChangeFilters = (flag: boolean, id: string) => {
    const tempFilters = filters.map((filter) => {
      if (filter.filterId === id) {
        return { ...filter, isSelected: flag };
      } return { ...filter };
    });
    setFilters(tempFilters);
    setSelectAll(allValueInKeyOfArrayExists(tempFilters, 'isSelected', true));
  };

  const onChangeCompanies = (companyId: number) => {
    setSelectedFilterCompanies((prev) =>
      prev.includes(companyId)
        ? prev.filter((id) => id !== companyId)
        : [...prev, companyId]
    );
  }

  const selectOrUnselectAll = (flag: boolean) => {
    const tempFilters = filters.map((filter) => ({ ...filter, isSelected: flag }));
    setFilters(tempFilters);
  };

  const onClickHandler = () => {
    selectOrUnselectAll(!selectAll);
    setSelectAll(!selectAll);
  };

  const applyFilterHandler = () => {
    const selectedNewsFilter = filters.filter((item) => item.isSelected).map((item) => item.filterId).join(',');
    const newsCompanyIds = selectedFilterCompanies.join(',');

    dispatch(clusterActions.setClusterCompanyNewsPageNumber(1));
    dispatch(clusterActions.setClusterNewsFilterApplied());
    dispatch(clusterActions.setClusterCompanyNewsFiltersApplied(selectedNewsFilter));
    dispatch(clusterActions.setClusterCompanyNewsFiltersSelected(selectedNewsFilter));
    dispatch(clusterActions.setClusterCompanyNewsCompanyIdsApplied(newsCompanyIds));
    dispatch(clusterActions.getClusterCompanyNews({
      companyId: newsCompanyIds,
      ...selectedNewsFilter.length ? {
        newsFilters: selectedNewsFilter
      } : {},
      page: 1,
    }));

    const companiesKey = selectedCompanies
      .map((company) => company.companyId)
      .sort((a, b) => a - b)
      .join(',');
    loadedTabsRef.current['Sales Triggers'] = `${companiesKey}-${selectedNewsFilter}-${newsCompanyIds}`;

    setPreviousNewsFiltersApplied(filters);
    setPreviousSelectedCompanyIds(selectedFilterCompanies);
    setIsFilterChanged(true);
  };

  const checkForApplyFilter = () => {
    const filtersChanged = filters.some(
      (filter, index) =>
        filter.isSelected !==
        previousNewsFiltersApplied[index]?.isSelected,
    );

    const companiesChanged =
      JSON.stringify([...selectedFilterCompanies].sort()) !==
      JSON.stringify([...previousSelectedCompanyIds].sort());

    return !(filtersChanged || companiesChanged);
  };

  useEffect(() => {
    if (isFilterChanged) {
      if (
        anyValueInKeyOfArrayExists(
          filters,
          'isSelected',
          false
        )
      ) {
        setIsFilterActive(true);
      } else {
        setIsFilterActive(false);
      }

      setIsFilterChanged(false);
    }
  }, [isFilterChanged, filters]);

  useEffect(() => {
    if (selectedNewsFilters.length) {
      const filterId = selectedNewsFilters.split(',');
      const filterTemp = newsFiltersFromRedux.map((filter) => {
        if (filterId.includes(filter.filterId)) {
          return { ...filter, isSelected: true };
        }
        return { ...filter, isSelected: false };
      });
      setFilters(filterTemp);
      setPreviousNewsFiltersApplied(filterTemp);
    } else {
      setFilters(newsFiltersFromRedux);
      setPreviousNewsFiltersApplied(newsFiltersFromRedux);
    }

    setSelectAll(allValueInKeyOfArrayExists(newsFiltersFromRedux, 'isSelected', true));
  }, [newsFiltersFromRedux]);

  return (
    <Wrapper ref={scrollContainerRef}>
      <>
        <div className='tabs-header-scroll wrap-slider hidden-scroll forOverFlow'>
          <div className='tabs-header'>
            <ClusterTabs
              tabs={tabs}
              activeTab={activeTab}
              setActiveTab={handleTabChange}
              scrollContainerRef={scrollContainerRef}
            />
            {
              activeTab === 'Sales Triggers' && (
                <div className={classNames('right-side-sub-header', { disabledFilter: (!companyNewsArticles?.length && !clusterNewsFilterApplied) || !filters.length || disableFilter })}>
                  <div className={classNames('view-tabs', {
                    notdisabledTabs: true,
                  })}
                  >
                    <ViewTabs
                      disabled={disableFilter}
                      listView={isListView}
                    />
                  </div>
                  <div className={classNames('filter-placeholder', {
                    notDisabledFilter: ((companyNewsArticles?.length) || clusterNewsFilterApplied) && filters.length > 0 && !disableFilter,
                  })}
                  >
                    <ClusterFilterPopover
                      filters={filters}
                      selectedCompanies={selectedCompanies as any}
                      selectedCompaniesId={selectedFilterCompanies as any}
                      loading={false}
                      selectAll={selectAll}
                      onChangeFilters={onChangeFilters}
                      onChangeCompanies={onChangeCompanies}
                      onClickHandler={onClickHandler}
                      applyFilterHandler={applyFilterHandler}
                      disableApplyBtn={checkForApplyFilter()}
                      iconMode={isTab}
                      isActive={isFilterActive && !disableFilter}
                      salesTriggerPopup
                      showContent={!disableFilter}
                    />
                  </div>
                </div>
              )
            }

          </div>
        </div>
        <div className="content-wrapper">
          {allCompanyDetailsLoading ? (
            <div className="not-applied-section loader">
              <img className='gilroy-loader' src={loadingGifV7} alt="loading" />
            </div>
          ) : (
            renderTabContent()
          )}
        </div>
      </>
    </Wrapper>
  );
};

ClusterInsightSection.defaultProps = defaultProps;
export default ClusterInsightSection;